import { ATP_API_URL } from "@config/apiconfig";
import apiClient from "@services/apiClient";

export const handleClaimAction = async (payload) => {
  try {
    let url = ATP_API_URL.CLAIM_DECISION;

    const response = await apiClient.post(url, payload);

    if (response?.data?.status) {
      return response.data;
    }

    return response?.data?.message || "Something went wrong, Please, try again";
  } catch (error) {
    throw error;
  }
};
